import { registerSecondScreenCode } from 'Api/ProfileApi';
import { getStoreState, setState } from 'Utils/Store';

export const secondScreenInitialState = {
  isDeviceActivation: false,
  code: '',
  device: '',
};

export const setSecondScreen = (payload) => {
  setState('secondScreen', payload);
};

export const resetSecondScreen = () => {
  setState('secondScreen', secondScreenInitialState);
};

export const registerSecondScreen = () => async () => {
  const {
    secondScreen: { code },
  } = getStoreState();

  await registerSecondScreenCode(code);
  resetSecondScreen();
};
